import gql from 'graphql-tag'

export default gql`
  fragment ImageAssetFragment on ImageAsset {
    image {
      dimensions {
        height
        width
      }
      url
    }
    imageMobile {
      dimensions {
        height
        width
      }
      url
    }
  }

  fragment ImageResourceImageFragment on Image {
    url
    dimensions {
      width
      height
    }
    pins {
      x
      y
      reference {
        ... on Page {
          __typename
          id
          type
        }
      }
    }
  }

  fragment ImageResourceFragment on ImageResource {
    id
    image {
      ...ImageResourceImageFragment
    }
    url
    mobileImage {
      ...ImageResourceImageFragment
    }
    mobileURL
    fields {
      ...FieldContent
    }
  }

  fragment VideoResourceFragment on VideoResource {
    asset {
      type
      key
    }
    settings
    mobileAsset {
      type
      key
    }
  }

  fragment ReferenceContent on Reference {
    __typename
    ... on ExternalLink {
      id
      url
    }
    ... on Link {
      image {
        url
      }
    }
    ... on Page {
      __typename
      id
      type
      title
      url
      brand {
        id
        logo
        title
      }
      openGraph {
        ...OpenGraphContent
      }
      fields {
        ... on ProductField {
          key
          product(mode: PROJECTION, combineVariants: true, onlyEnabled: true, sortVariants: true) {
            ...ProductContent
          }
        }
      }
    }
    ... on Media {
      __typename
      id
      title
      captionOptions {
        caption
        references {
          ... on Page {
            __typename
            id
            type
            fields {
              ... on ProductField {
                __typename
                key
                product(mode: PROJECTION, combineVariants: true, onlyEnabled: true, sortVariants: true) {
                  ...ProductContent
                }
              }
            }
          }
        }
      }
      overlayOptions {
        icon
        caption
        position
      }
    }
    ...ImageAssetFragment
    ...ImageResourceFragment
    ...ImageResourceImageFragment
    ...VideoResourceFragment
    ... on TileResource {
      id
      title
      display
      header
      description {
        key
        referencesWithKey {
          key
          reference {
            ... on Page {
              id
              type
              url
            }
            ... on ExternalLink {
              url
            }
          }
        }
        value
      }
      button {
        text
        link {
          newTab
          url
        }
      }
      campaignTag {
        __typename
        text {
          __typename
          key
          referencesWithKey {
            key
            reference {
              ... on Page {
                id
                type
                url
              }
              ... on ExternalLink {
                url
              }
            }
          }
          value
        }
        appearance {
          __typename
          asset {
            ...ImageAssetFragment
            ...ImageResourceFragment
            ...ImageResourceImageFragment
            ...VideoResourceFragment
          }
          backgroundColor
          textColor
        }
      }
      references {
        ...ImageAssetFragment
        ...ImageResourceFragment
        ...ImageResourceImageFragment
      }
      appearance {
        asset {
          ...ImageAssetFragment
          ...ImageResourceFragment
          ...ImageResourceImageFragment
          ...VideoResourceFragment
        }
        backgroundColor
        textColor
      }
    }
  }
`
